import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
export const downloadFile = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const axiosConfig = {
        method: 'GET',
        url,
        responseType: 'blob',
        withCredentials: true,
    };
    try {
        const response = yield axiosClient.request(axiosConfig);
        const blob = response.data;
        const objectUrl = URL.createObjectURL(blob);
        try {
            const link = window.open(objectUrl, '_blank');
            if (!link) {
                throw new Error('Failed to open new tab. Popup may be blocked.');
            }
        }
        finally {
            setTimeout(() => URL.revokeObjectURL(objectUrl), 100);
        }
    }
    catch (error) {
        console.error('File download failed', error instanceof Error ? error.stack : String(error), {
            context: 'downloadFile',
            url,
        });
        throw error;
    }
});
